import { createRoot } from 'react-dom/client';
import App from './projects/App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);